<template>
    <p-modal v-if="display">
        <div slot="content">
            <div class="title">
                變更手機
            </div>
            <div class="error">
                {{ err }}
            </div>
            <div class="subtitle" v-if="page === 'change'">
                <input type="tel" v-model="phone" placeholder="09xxxxxxxx">
            </div>
            <div class="subtitle" v-else>
                <div class="phone">
                    {{ this.phone }}
                </div>
                <input type="text" v-model="code" placeholder="請輸入簡訊驗證碼...">
            </div>
        </div>
        <div slot="buttons" class="buttons">
            <div class="cancel button" @click="onCancel">
                取消
            </div>
            <div class="confirm button" @click="change" v-if="page === 'change'">
                變更
            </div>
            <div class="confirm button" @click="verify" v-else>
                驗證
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';
    import { mapActions } from 'vuex';
    import * as apis from '../../../apis';
    import Swal from 'sweetalert2'

    export default {
        name: 'ChangePhoneModal',
        components: {
            'p-modal': Modal
        },
        data() {
            return {
                page: 'change',
                display: false,
                phone: '',
                code: '',
                err: '',
            };
        },
        methods: {
            change() {
                if (! this.phone.match(/^09\d{8}$/)) {
                    this.err = '手機格式錯誤';
                    return true;
                }

                this.err = '';

                apis.changePhone(this.phone).then(() => {
                    this.page = 'verify';
                }).catch(err => {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                });
            },
            verify() {
                let payload = {
                    'phone': this.phone,
                    'code': this.code,
                };

                this.verifyPhone(payload).then(() => {
                    this.display = false;
                }).catch(err => {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                });
            },
            onCancel() {
                this.display = false;
                this.$emit('onCancel');
            },
            show() {
                this.display = true;
            },
            ...mapActions(['verifyPhone'])
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
    }

    .error {
        height: 20px;
        color: rgba(244,67,54,1);
        font-size: 10px;
        font-weight: 500;
        text-align: left;
    }

    .subtitle {
        color: rgba(120,120,120,1);
        font-family: "PingFang TC";
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        margin-top: 5px;

        input {
            width: 100%;
            border-radius: 4px;
            border: 1px solid #DDDDDD;
            padding: 6px 10px;
            box-sizing: border-box;
            font-family: "PingFang TC";
            font-size: 14px;
            line-height: 20px;
        }
    }

    .buttons {
        display: flex;

        .button {
            width: calc(50% - 1px);
            font-family: "PingFang TC";
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            padding: 12px 0;

            &.cancel {
                color: rgba(155,155,155,1);
            }

            &.confirm {
                color: rgba(244,67,54,1);
            }

            &:first-child {
                border-right: solid 1px rgba(221,221,221,1);
            }
        }
    }
</style>
